export default __webpack_public_path__ + "static/media/spicycupcake.d05c522f.jpg";